import React, { useState } from "react";
import tooltips from "../../../data/Tooltips/tooltips.json";
import { HelpOutline } from "@mui/icons-material";
import Modal from "../../common/Modal/Modal";

import "./GeneralTooltipsModal.css";

/* 
This modal shows the Glossary terms defined by HecoRep 
Input: generalTooltips.json
Output: shows data in a modal
*/

export default function GeneralTooltipsModal() {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // Close the success modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <div className="general-tooltips-modal">
      <button
        className="generaltooltips-modal-button"
        onClick={handleOpenModal}
      >
        <HelpOutline />
      </button>
      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={"Form Information"}
        showCustomContent={true}
        customContent={
          <div>
            {tooltips.Properties.map((item, index) => (
              <div key={index} className="general-tooltips-content">
                <p className="maps-text">
                  <span>{item.key}</span> : {item.description}
                </p>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
}
